/* eslint-disable no-unused-vars */
'use client';

import { createContext, useState, ReactNode } from 'react';

interface authenticationModalContextProps {
  visivel: boolean;
}

interface AuthenticationModalContextType {
  authenticationModalContextProps: authenticationModalContextProps;
  mostrarAuthenticationModalContext: () => void;
  esconderAuthenticationModalContext: () => void;
}

export const AuthenticationModalContext = createContext<
  AuthenticationModalContextType | undefined
>(undefined);

export const AuthenticationModalProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const authenticationModalContextDefault: { visivel: boolean } = {
    visivel: false,
  };

  const [authenticationModalContextProps, setAuthenticationModalContextProps] =
    useState<authenticationModalContextProps>(
      authenticationModalContextDefault,
    );

  const mostrarAuthenticationModalContext = () => {
    setAuthenticationModalContextProps({
      visivel: true,
    });
  };

  const esconderAuthenticationModalContext = () => {
    setAuthenticationModalContextProps({
      visivel: false,
    });

    setTimeout(() => {
      setAuthenticationModalContextProps(authenticationModalContextDefault);
    }, 400);
  };

  return (
    <AuthenticationModalContext.Provider
      value={{
        authenticationModalContextProps,
        mostrarAuthenticationModalContext,
        esconderAuthenticationModalContext,
      }}
    >
      {children}
    </AuthenticationModalContext.Provider>
  );
};
